import React from 'react';
import { Snackbar } from '@material-ui/core';
import { Alert } from '@material-ui/lab';

const PageToast = (props: Props): React.ReactElement => {
  const { message, onClose } = props;
  return (
    <Snackbar
      open={!!message}
      autoHideDuration={8000}
      onClose={onClose}
      anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
    >
      <Alert severity="error" onClose={onClose}>
        {message}
      </Alert>
    </Snackbar>
  );
};

interface Props {
  message: string;
  onClose: () => void;
}

export default PageToast;
